var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustedrouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h18v4h-7v12h-4V8H3V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10h2.75C20.65 10 23 12.35 23 15.25S20.65 20.5 17.75 20.5H15v-4h2.75c.69 0 1.25-.56 1.25-1.25S18.44 14 17.75 14H15v-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedrouter);
export default __webpack_public_path__ + "static/media/trustedrouter.47ce7630f10e876c1a9742ea3ccf12b8.svg";
export { ForwardRef as ReactComponent };